import {
    restQuery,
    QueryResult,
    BaseModel,
    restMutation,
    MutationResult,
} from 'vue-apollo-model';

export interface CategoryInfoType {
    categoryId: number;
    categoryName: string;
    isLeaf: boolean;
    children?: Array<CategoryInfoType>;
    categoryDesc?: string;
}
// 创建电商应用
export class MerchantModel extends BaseModel {
    @restMutation<MerchantModel>({
        url: '/portal/app/merchant/create',
        method: 'post',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    createMerchantMutation!: MutationResult<any, any>;

    async createMerchant(params: Record<string, any>) {
        await this.createMerchantMutation.mutate(params);
        return this.createMerchantMutation.data;
    }
    // 重新提交电商应用
    @restMutation<MerchantModel>({
        url: '/portal/app/merchant/resubmit',
        method: 'post',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    resubmitMerchantMutation!: MutationResult<any, any>;

    async resubmitMerchant(params: Record<string, any>) {
        await this.resubmitMerchantMutation.mutate(params);
        return this.resubmitMerchantMutation.data;
    }

    // 编辑提交电商应用
    @restMutation<MerchantModel>({
        url: '/portal/app/merchant/update',
        method: 'post',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    updateMerchantMutation!: MutationResult<any, any>;

    async updateMerchant(params: Record<string, any>) {
        await this.updateMerchantMutation.mutate(params);
        return this.updateMerchantMutation.data;
    }

    @restMutation<MerchantModel>({
        url: '/portal/app/merchant/categoryInfo',
        method: 'get',
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    merchantCategoryInfoMutation!: MutationResult<any, any>;

    async getCategoryList() {
        await this.merchantCategoryInfoMutation.mutate({});
        return this.merchantCategoryInfoMutation.data?.categoryList;
    }

    // 电商资质草稿
    @restMutation<MerchantModel>({
        url: '/portal/developer/v3/merchant/draft',
        method: 'post',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    merchantDraftMutation!: MutationResult<any, any>;

    async merchantDraft(params: Record<string, any>) {
        await this.merchantDraftMutation.mutate(params);
        return this.merchantDraftMutation.data;
    }

    // 申请完善第三方开发者电商资质
    @restMutation<MerchantModel>({
        url: '/portal/developer/v3/merchant/update',
        method: 'post',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    merchantUpdateMutation!: MutationResult<any, any>;

    async merchantUpdate(params: Record<string, any>) {
        await this.merchantUpdateMutation.mutate(params);
        return this.merchantUpdateMutation.data;
    }
    // 查询电商应用详情
    @restMutation<MerchantModel>({
        url: '/portal/app/merchant/appinfo',
        method: 'get',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    merchantAppInfoMutation!: MutationResult<any, any>;

    async merchantAppInfo(params: Record<string, any>) {
        await this.merchantAppInfoMutation.mutate(params);
        return this.merchantAppInfoMutation.data;
    }
    get appInfo() {
        return this.merchantAppInfoMutation.data?.appInfo || {};
    }
    // 查询电商应用scope信息
    @restMutation<MerchantModel>({
        url: '/portal/app/merchant/appScopes',
        method: 'get',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    merchantAppScopesMutation!: MutationResult<any, any>;

    async merchantAppScopes(params: Record<string, any>) {
        await this.merchantAppScopesMutation.mutate(params);
        return this.merchantAppScopesMutation.data;
    }

    get apiInfos() {
        return this.merchantAppScopesMutation.data?.scopes || [];
    }
    // 申请scope
    @restMutation<MerchantModel>({
        url: '/portal/app/merchant/applyScope',
        method: 'post',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    merchantApplyScopeMutation!: MutationResult<any, any>;

    async merchantApplyScope(params: Record<string, any>) {
        await this.merchantApplyScopeMutation.mutate(params);
        return this.merchantApplyScopeMutation.data;
    }
    // 电商应用查看signSecret
    @restMutation<MerchantModel>({
        url: '/portal/app/signSecret',
        method: 'get',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    signSecretMutation!: MutationResult<any, any>;

    async getSignSecret(params: Record<string, any>) {
        await this.signSecretMutation.mutate(params);
        return this.signSecretMutation.data;
    }
    // 电商应用查看messageSecret
    @restMutation<MerchantModel>({
        url: '/portal/app/messageSecret',
        method: 'get',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    messageSecretMutation!: MutationResult<any, any>;

    async getMessageSecret(params: Record<string, any>) {
        await this.messageSecretMutation.mutate(params);
        return this.messageSecretMutation.data;
    }

    // 网站应用  气泡信息是否已读
    @restMutation<MerchantModel>({
        url: '/portal/notice/bubble/unread',
        method: 'get',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    bubbleUnreadMutation!: MutationResult<any, any>;

    async getBubbleUnread() {
        await this.bubbleUnreadMutation.mutate({});
    }
    get isShowMerchantBubble() {
        return this.bubbleUnreadMutation.data.bubbleIds?.includes(
            'MERCHART_APP_CREATE_TIPS',
        );
    }

    // 网站应用  气泡信息标记已读
    @restMutation<MerchantModel>({
        url: '/portal/notice/bubble/read',
        method: 'post',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    bubbleReadMutation!: MutationResult<any, any>;

    async postBubbleRead(params: Record<string, any>) {
        await this.bubbleReadMutation.mutate(params);
    }
}
